import { UPGRADES_MAP } from '@flows/configs/contents/constants'
import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const contents_bike = (params: ContentsNeoStepConfigParams) => {
  const bikeProductKey = UPGRADES_MAP.bikeProductKey[params.productKey]
  return {
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.bike.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: `product_keys.${bikeProductKey}`,
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.no',
            },
            value: false,
          },
        ],
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_contents:steps.contents.bike.subtitle',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: `product_keys.${bikeProductKey}`,
      valueToStepName: {
        true: 'contents_bike_insured_sum',
        false: 'wg_insured',
      },
    },
  } as const satisfies AnyStepConfiguration
}

export default contents_bike
